import React from 'react'
import { makeStyles, Tooltip } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  largeToolTip: {
    fontSize: (props) => props.fontSize || '17px',
    whiteSpace: (props) => props.whiteSpace,
    maxWidth: (props) => props.maxWidth,
  },
}))

/**
 * 
 * @param {Object} props passed to the tooltip
 * @property {String} props.tooltipclass - optional class styles passed to makestyles, can have fontSize, whiteSpace, maxWidth
 * @property {Node} props.children - the content to wrap with a tooltip]
 * @property {String} props.classes - passed to the tooltip wrapper
 * @property {String} props.title - passed to the tooltip as text to display when the child is hovered
 * @returns {Node} Tooltip wrapper
 */
const LargeToolTip = (props) => {
  const classes = useStyles(props.tooltipclass)
  return (
    <Tooltip
      enterDelay={200}
      enterNextDelay={50}
      classes={{
        ...props.classes,
        tooltip: classes.largeToolTip,
      }}
      {...props}
    >
      {props.children}
    </Tooltip>
  )
}

export default LargeToolTip
